import { Stack, Container, Box, Tabs, Tab, useTheme } from '@mui/material';
import React from 'react';
import { useMediaQuery } from 'usehooks-ts';
import GettingStarted from './GettingStarted';
import UnderstandingSkill from './UnderstandingSkill';
import UnderstandingCompany from './UnderstandingCompany';
import JobfactorScore from './JobfactorScore';
import FAQs from './FAQs';

const HowJobfactorWorks = () => {
    const theme = useTheme();
    const medium = useMediaQuery(theme.breakpoints.down('md'));
    const mobile = useMediaQuery(theme.breakpoints.down('lg'));
    const [value, setValue] = React.useState('Getting Started on Jobfactor');

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    const tabList = [
        { name: 'Getting Started on Jobfactor', label: 'Getting Started on Jobfactor', index: 0 },
        { name: 'Understanding Skill Competency Levels: A User Guide', label: 'Understanding Skill Competency Levels: A User Guide', index: 1},
        { name: 'Understanding Company Rating Dimensions and Scales: A User Guide', label: 'Understanding Company Rating Dimensions and Scales: A User Guide', index: 2},
        { name: 'Jobfactor Score guide: Understanding the different levels of Jobfactor score', label: 'Jobfactor Score guide: Understanding the different levels of Jobfactor score', index: 3},
        { name: 'Frequently Asked Questions (FAQ)', label: 'FAQ (General)', index: 4},
        
    ];

    return (
        <Stack pt={{xs: '60px', sm:'100px'}} sx={{background: `linear-gradient(255deg, #f1fbff 0%, #fff3f5 100%)`,}}>
            <Container
                maxWidth="xl"
                disableGutters
                sx={{
                    px: { xs: '20px', md: '85px' },
                    py: { xs: '60px', md: '100px' }
                }}
            >
                <Box display='flex' alignItems={{xs: 'center', sm: 'flex-start'}} flexDirection={{xs: 'column', sm: 'row'}} gap={{xs: '40px', sm:'50px'}}>
                    <Tabs
                        orientation="vertical"
                        value={value}
                        onChange={handleChange}
                        aria-label="Vertical tabs example"
                        sx={{
                            // width: '100%',
                            minWidth: '300px',
                            height: '100%',
                            '& .MuiTabs-indicator': { color: '#000' }
                        }}
                    >
                        {tabList.map((tab) => (
                            <Tab
                                key={tab.index}
                                value={tab.name}
                                label={tab.label}
                                tabIndex={tab.index}
                                sx={{
                                    textAlign: 'left',
                                    textTransform: 'none',
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    color: '#000',
                                    p: 0
                                }}
                            />
                        ))}
                    </Tabs>
                        {value === 'Getting Started on Jobfactor' ? <GettingStarted /> : value ==='Understanding Skill Competency Levels: A User Guide' ? <UnderstandingSkill /> : value === 'Understanding Company Rating Dimensions and Scales: A User Guide' ? <UnderstandingCompany /> : value === 'Jobfactor Score guide: Understanding the different levels of Jobfactor score' ? <JobfactorScore /> : <FAQs />}
                </Box>
            </Container>
        </Stack>
    );
};

export default HowJobfactorWorks;
